import { name as packageName, version as packageVersion } from '../../../package.json';
export var hoveredPayload = {
  action: 'displayed',
  actionSubject: 'tooltip',
  attributes: {
    componentName: 'tooltip',
    packageName: packageName,
    packageVersion: packageVersion
  }
};
export var unhoveredPayload = {
  action: 'hidden',
  actionSubject: 'tooltip',
  attributes: {
    componentName: 'tooltip',
    packageName: packageName,
    packageVersion: packageVersion
  }
};